import { Link } from "react-router-dom";
import { Image_URL } from "../App";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faClock, faPlay } from '@fortawesome/free-solid-svg-icons';
import '../styles/card.css';

function CardNot({ cardonline, cardcenter , style}) {
  function formatDate(dateString) {
    try {
      const date = new Date(dateString);
      const options = { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC', numberingSystem: 'arab' };
      const formatter = new Intl.DateTimeFormat('ar-EG', options);
      return formatter.format(date);
    } catch (e) {
      return '';
    }
  }

  const cardData = cardonline || cardcenter;

  return (
    <div className={`stylish-card ${style ? 'dark-mode' : ''}`}>
      <div className="image-container">
        <img src={`${Image_URL}/storage/${cardData.attributes.img}`} alt={cardData.attributes.name} loading="lazy" />
        <div className="overlay"></div>
        <div className="play-icon">
          <FontAwesomeIcon icon={faPlay} />
        </div>
        {cardData.attributes.price === '0.00' ? (
          <div className="tag free-tag">هذا الكورس مجاني</div>
        ) : cardData.attributes.old_price !== '' ? (
          <div className="tag offer-tag">{`%${(((cardData.attributes.old_price - cardData.attributes.price) * 100) / cardData.attributes.old_price).toFixed(0)} خصم`}</div>
        ) : null}
      </div>
      <div className="content-body">
        <h3 className="card-title">{cardData.attributes.name}</h3>
        <div className="card-description" dangerouslySetInnerHTML={{ __html: cardData?.attributes?.description?.replace(/\r\n/g, '<br>').replace(/\n/g, '<br>') }}></div>
        <div className="info-bar">
          <div className="info-item">
            <FontAwesomeIcon icon={faCalendarAlt} />
            <span>{formatDate(cardData.attributes.created_at)}</span>
          </div>
          <div className="info-item">
            <FontAwesomeIcon icon={faClock} />
            <span>{formatDate(cardData.attributes.updated_at)}</span>
          </div>
        </div>
        <div className="price-bar">
          <span className="current-price">{cardData.attributes.price === '0.00' ? '' : `${cardData.attributes.price} جنيه`}</span>
          {cardData.attributes.old_price !== '' && <span className="old-price">{cardData.attributes.old_price}.00 جنيه</span>}
        </div>
        <div className="actions">
          <Link to={`/course-content/${cardData.id}`} className="btn-secondary">تفاصيل الكورس</Link>
          <Link to="/registeruser" className="btn-primary">اشترك الآن</Link>
        </div>
      </div>
    </div>
  );
}

export default CardNot;